import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { BookedService, NgxToastrService, UtilsService } from '@core/services'
import {
  NgbActiveModal,
  NgbDateParserFormatter,
  NgbModal
} from '@ng-bootstrap/ng-bootstrap'
import { TranslateService } from '@ngx-translate/core'
import moment from 'moment'
import swal from "sweetalert2";
import { Subscription } from "rxjs";
import { ExpiredModalComponent } from '@shared/component/expired-modal/expired-modal.component'

@Component({
  selector: 'app-summary-booked',
  templateUrl: './summary-booked.component.html',
  styleUrls: ['./summary-booked.component.scss']
})
export class SummaryBookedComponent implements OnInit, OnDestroy {
  canRequest: boolean
  @Input() userBookingOption
  @Input() hotel
  @Input() totalAdults
  @Input() totalChildrens
  @Input() searchConfig
  @Input() roomsBooked
  @Input() code: string
  @Input() uuidUser: string
  @Input() company
  @Input() isAdmin: boolean
  @Input() selectedRooms;
  @Input() selectedUsers;
  @Input() guests: [] = [];
  @Input() isSummaryRequest: boolean;
  @Input() starAuthRequired: boolean;
  @Input() canOnlyRequestRooms: boolean;
  @Input() isEmployee: boolean;
  form: UntypedFormGroup
  loading: boolean = false
  disabled: boolean = false
  @Output() sendInfo = new EventEmitter<any>()
  @Output() selectedRoomChanged: EventEmitter<any> = new EventEmitter<any>();
  @Input() totalPrice: number
  actualRoom: number
  showPolicies: boolean
  actualGroupRoom: number
  roomsSelected: any[]
  priceChanged = false;
  priceChangeAccepted = false;
  newTotalPrice: number | null = null;
  subscriptions: Subscription[] = [];
  expectedIds = new Set<string>();
  receivedIds = new Set<string>();
  expectedCount = 0;
  private receivedCount = 0;
  flightInfo;
  acceptPackage: boolean = false;
  isPackageRate: string;
  private expiredModalOpen = false;
  private expiredHandledCorrelationIds = new Set<string>();

  constructor (
    private activatedRoute: ActivatedRoute,
    private ngbDateParser: NgbDateParserFormatter,
    private activeModal: NgbActiveModal,
    private formBuilder: UntypedFormBuilder,
    private translate: TranslateService,
    public utilsService: UtilsService,
    private ngxToastrService: NgxToastrService,
    private bookedService: BookedService,
    private modalService: NgbModal
  ) {
    this.utilsService.socket.on("check-rate-booking", (result) => {
      this.loading = false;
      if (!!this.selectedRooms.find((room) => room.correlationId === result.correlationId)) {
        this.markReceivedAndMaybeStopLoading(result.correlationId);
        const cid = result?.correlationId;
        const isExpired = result?.data?.statusCode === 817 || result?.data?.errorCode === 'TOKEN_EXPIRED';

        if (isExpired) {
          if (cid && this.expiredHandledCorrelationIds.has(cid)) return;
          if (cid) this.expiredHandledCorrelationIds.add(cid);

          if (this.expiredModalOpen) return;
          this.expiredModalOpen = true;

          this.activeModal.dismiss();

          const modalRef = this.modalService.open(ExpiredModalComponent, {
            windowClass: 'custom-modal-expired',
            centered: true,
            backdrop: 'static',
            keyboard: false,
          });

          modalRef.componentInstance.redirectTo = `/search/${this.uuidUser}`;

          modalRef.result.finally(() => {
            this.expiredModalOpen = false;
            this.expiredHandledCorrelationIds.clear();
          });

          return;
        }
        if((result.data.type && (result.data.type?.toLowerCase().includes("error") || result.data.type?.toLowerCase().includes("exception"))) || (result.data.bookingStatus && (result.data.bookingStatus?.toLowerCase().includes('unknown') || result.data.bookingStatus?.toLowerCase().includes('error')))) {
          if (result?.data?.message.toLowerCase().includes("insufficient allotment")) {
            this.translate
              .get(['hotel.errors.insufficient-allotment'])
              .subscribe(res => {
                this.ngxToastrService.typeInfo(res['hotel.errors.insufficient-allotment'], '')
              })
          } else {
            this.translate
            .get(['hotel.errors.check-rate', 'common.errors.try-again'])
            .subscribe(res => {
              this.ngxToastrService.typeInfo(res['hotel.errors.check-rate'], res['common.errors.try-again'])
            })
          }
          this.activeModal.dismiss()
        } else {
          let roomOriginal: any = {};
          if ((this.code.toString().charAt(0) === "E" && (result.data.status === "Available" || result.data.status === "PriceChanged"))){
            roomOriginal = this.selectedRooms.filter((room) => room.code === result.data.reference && room.rates.find((rate) => rate.rateKey.split("E")[1] === result.data.accommodation.rooms[0].rates[0].rateKey /* && !rate.price */))
          } else if (this.code.toString().charAt(0) !== "E" && (result.data.status === "Available" || result.data.status === "PriceChanged")) {
            roomOriginal = this.selectedRooms.filter((room) => room.code === result.data.reference && room.rates.find((rate) => rate.rateKey === result.data.accommodation.rooms[0].rates[0].rateKey /* && !rate.price */))
          }
          roomOriginal.map((r) => {
            r.rates[0].price = result.data.price
            r.rates[0].wholesalePrice = result.data.wholesalePrice
            r.correlationId = result.correlationId;
          });

          if (result?.data?.status === 'PriceChanged') {
            this.priceChanged = true;
            this.priceChangeAccepted = false;
          }
          this.newTotalPrice = this.getTotalPrice();
        }
      }
    })
  }

  ngOnDestroy (): void {
    this.utilsService.socket.off("check-rate-booking");
  }

  ngOnInit () {
    this.isPackageRate = localStorage.getItem("isPackageRate")
    const flight = localStorage.getItem("packageRateFlightInfo");
    if (flight) {
      this.flightInfo = JSON.parse(flight)
    }
    this.canRequest =
      this.activatedRoute.snapshot.queryParams.canRequest === 'true'
        ? true
        : false
    this.form = this.formBuilder.group({
      customCode: [null],
      costCenter: [null],
      travellerReason: [null],
      adminHotelComment: [null],
    })

    this.roomsSelected = [...this.selectedRooms];
    this.loading = true;

    this.roomsSelected.forEach((rooms) => {
      const parsedRoom = {...rooms};
      parsedRoom.nameRoom = rooms.name;
      parsedRoom.net = rooms.rates[0].net;
      parsedRoom.totalWithPercentage = rooms.rates[0].totalWithPercentage;
      parsedRoom.rateType = rooms.rates[0].rateType;
      parsedRoom.rateKey = rooms.rates[0].rateKey;
      parsedRoom.cancellation = !!rooms.rates[0].cancellationPolicies
      parsedRoom.cancellationPolicies = rooms.rates[0].cancellationPolicies
      parsedRoom.cancellationPolicies?.forEach((item, index, array) => {
        array[index] = {
          amount: item.amount,
          amountWithPercentage: item.amountWithPercentage,
          from: item.from,
          text: item.text,
        }
      });
    
      const body = {
        rooms: [parsedRoom],
        userUuid: this.uuidUser,
        checkIn: `${this.searchConfig.checkIn.year}-${this.searchConfig.checkIn.month}-${this.searchConfig.checkIn.day}`,
        checkOut: `${this.searchConfig.checkOut.year}-${this.searchConfig.checkOut.month}-${this.searchConfig.checkOut.day}`,
        guests: this.guests.splice(0, rooms.paxes.length),
        accommodationCode: this.hotel.code.slice(1),
      };
      const correlation = crypto.randomUUID();
      this.utilsService.correlationId.push(correlation)
      body['correlationId'] = correlation;
      rooms.correlationId = correlation
      this.bookedService.checkRate(body).subscribe((rate) => {
        rooms.correlationId = correlation;
      })
    })
    this.buildExpectedTrackers();
  }

  getTermsOfUseLink(isAgent): string {
    const language = this.translate.currentLang;
    return !isAgent
      ? `https://developer.ean.com/terms/${language}`
      : `https://developer.ean.com/terms/agent/${language === 'es' ? 'es-es' : 'en'}`;
  }

  get f () {
    return this.form.controls
  }

  formatDate (date) {
    return this.ngbDateParser.format(date)
  }

  closeModal () {
    this.activeModal.dismiss('Cross click')
  }

  onSubmit() {
    this.disabled = true;

    if (this.priceChanged && !this.priceChangeAccepted) {
      this.newTotalPrice = this.getTotalPrice();
      const priceTxt = this.newTotalPrice != null ? `${this.newTotalPrice.toFixed(2)}€` : '';

      this.subscriptions.push(
        this.translate.get([
          "hotel.priceChanged.title",
          "hotel.priceChanged.message",
          "common.confirm",
          "common.cancel"
        ]).subscribe((res) => {
          swal.fire({
            title: res["hotel.priceChanged.title"],
            text: res["hotel.priceChanged.message"].replace("{price}", priceTxt),
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: res["common.confirm"],
            cancelButtonText: res["common.cancel"],
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.priceChangeAccepted = true;
              this.emitSubmit();
            } else {
              this.resetPriceChangeState();
              this.closeModal();
            }
          });
        })
      );

      return;
    }

    this.emitSubmit();
  }

  private emitSubmit() {
    const send = {
      rooms: this.selectedRooms,
      customCode: this.f.customCode.value ?? '',
      costCenter: this.f.costCenter.value ?? '',
      travellerReason: this.f.travellerReason.value ?? ''
    };

    if (this.f.adminHotelComment?.value) {
      send['adminHotelComment'] = this.f.adminHotelComment.value;
    }

    this.sendInfo.emit(send);
  }

  isSameOrAfterToday(date) {
    return date ? moment(date).isSameOrAfter(moment()) : null;
  }

  getTotalPrice() {
    let totalPrice = 0;
    this.selectedRooms.forEach((room) => {
      room.rates.forEach((rate) => {
        totalPrice += rate.price && rate.price.totalPrice ? Number(rate.price.totalPrice.total) : Number(rate.totalWithPercentage);
      })
    })

    if (this.flightInfo) {
      totalPrice += this.flightInfo.totalPrice
    }
    return totalPrice;
  }

  isPackage() {
    return this.selectedRooms.some((room) => room.rates.some((rate) => rate.saleScenario?.package === true))
  }
  private resetPriceChangeState() {
    this.priceChanged = false;
    this.priceChangeAccepted = false;
    this.newTotalPrice = null;
    this.disabled = false;
  }

  private markReceivedAndMaybeStopLoading(id?: string) {
    if ((!this.expectedIds || this.expectedIds.size === 0) && (!this.expectedCount || this.expectedCount === 0)) {
      this.buildExpectedTrackers();
    }

    if (id) {
      const before = this.receivedIds.size;
      this.receivedIds.add(id);
      if (this.receivedIds.size > before) {
        this.receivedCount++;
      }
    } else {
      this.receivedCount++;
    }

    const target = this.expectedIds.size > 0 ? this.expectedIds.size : this.expectedCount;

    if (target > 0 && this.receivedCount >= target) {
      this.loading = false;
    }
  }

  private buildExpectedTrackers() {
    this.receivedIds.clear();
    this.receivedCount = 0;
    this.priceChanged = false;
    this.priceChangeAccepted = false;

    const arr = Array.isArray(this.selectedRooms) ? this.selectedRooms : [];
    if (arr.length === 0) return;

    const ids = arr
      .map((r: any) => r?.correlationId || r?.correlationID || r?.rates?.[0]?.correlationId)
      .filter(Boolean);

    if (ids.length > 0) {
      this.expectedIds = new Set<string>(ids);
      this.expectedCount = this.expectedIds.size;
    } else {
      this.expectedIds = new Set<string>();
      this.expectedCount = arr.length;
    }
  }

  acceptPackageFunc() {
    this.acceptPackage = !this.acceptPackage;
  }
  
}
